import React from 'react';
import { Instagram } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-[#09090b] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h1 className="text-4xl md:text-6xl font-bold mb-16 text-center" style={{fontFamily: 'Syne, sans-serif'}} data-testid="about-title">Sobre Nosotras</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold mb-4" style={{fontFamily: 'Syne, sans-serif'}}>Nuestra Historia</h2>
              <p className="text-zinc-400 leading-relaxed">
                Booty and Legs Academy nació de nuestra pasión por empoderar a mujeres a través del fitness. Con años de experiencia en entrenamiento y nutrición, decidimos crear una plataforma donde todas pudieran acceder a programas de calidad.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{fontFamily: 'Syne, sans-serif'}}>Nuestra Misión</h3>
              <p className="text-zinc-400 leading-relaxed">
                Transformar vidas a través del entrenamiento especializado y el desarrollo del mindset, creando una comunidad de mujeres fuertes y empoderadas.
              </p>
            </div>
          </div>
          <div className="space-y-6">
            <div className="workout-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-4">
                <img src="https://images.unsplash.com/photo-1683848644078-f339179c4ff6?crop=entropy&cs=srgb&fm=jpg&q=85" alt="Deisy" className="w-24 h-24 rounded-full object-cover" />
                <div>
                  <h4 className="text-xl font-bold" style={{fontFamily: 'Syne, sans-serif'}}>Deisy</h4>
                  <a href="https://instagram.com/deisyfit" target="_blank" rel="noopener noreferrer" className="text-pink-600 flex items-center">
                    <Instagram className="w-4 h-4 mr-2" />@deisyfit
                  </a>
                </div>
              </div>
              <p className="text-zinc-400">Entrenadora certificada con especialización en entrenamiento de fuerza.</p>
            </div>
            <div className="workout-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-4">
                <img src="https://images.unsplash.com/photo-1669502299593-5dbb23edfdb4?crop=entropy&cs=srgb&fm=jpg&q=85" alt="Karen" className="w-24 h-24 rounded-full object-cover" />
                <div>
                  <h4 className="text-xl font-bold" style={{fontFamily: 'Syne, sans-serif'}}>Karen Marino</h4>
                  <a href="https://instagram.com/karenmarinob" target="_blank" rel="noopener noreferrer" className="text-pink-600 flex items-center">
                    <Instagram className="w-4 h-4 mr-2" />@karenmarinob
                  </a>
                </div>
              </div>
              <p className="text-zinc-400">Nutricionista deportiva y entrenadora especializada en transformaciones corporales.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;